<template>
  <div class="multi-text">
    <span class="multi-text__count" v-if="hasCountLimits">
      {{ items.length
      }}<template v-if="settings.max_count"> / {{ settings.max_count }}</template>
    </span>
    <div class="multi-text__error" v-if="belowMin">
      Minimum of {{ settings.min_count }} required.
    </div>
    <div class="multi-text__item" v-for="(item, idx) in items" :key="idx">
      <v-text-field
        :placeholder="label"
        v-model="items[idx]"
        hide-details
      ></v-text-field>
      <v-btn icon :disabled="atMin" @click="deleteItem(idx)">
        <v-icon>$delete</v-icon>
      </v-btn>
    </div>
    <v-btn outlined :disabled="atMax" @click="addItem">+ Add</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    settings: Object,
    label: String,
    links: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      items: [...(this.value || [])],
    };
  },
  computed: {
    hasCountLimits() {
      return !!(this.settings.min_count || this.settings.max_count);
    },
    atMin() {
      return (
        !!this.settings.min_count &&
        this.items.length <= Number(this.settings.min_count)
      );
    },
    atMax() {
      return (
        !!this.settings.max_count &&
        this.items.length >= Number(this.settings.max_count)
      );
    },
    belowMin() {
      return (
        !!this.settings.min_count &&
        this.items.length < Number(this.settings.min_count)
      );
    },
  },
  methods: {
    addItem() {
      this.items.push("");
    },
    deleteItem(idx) {
      this.items.splice(idx, 1);
    },
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit("input", [...this.items]);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.multi-text {
  &__count {
    font-weight: 400;
    font-size: 13px;
    color: #8a8a8e;
  }

  &__error {
    color: #d32f2f;
    font-size: 13px;
    margin-bottom: 10px;
  }

  &__item {
    display: flex;
    align-items: center;
  }
}
</style>
